
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import {Getter} from "vuex-class";
import "vue-datetime/dist/vue-datetime.css";
import SimpleDialog from "@/components/SimpleDialog.vue";

@Component({
  components: { SimpleDialog },
})
export default class MissionOrderAssignModal extends Vue {

    get isFormValid(): boolean {
      return !!this.assignedUserGroupId && !this.displayCreateUserGroup || (
        this.newUserGroup?.name && this.newUserGroup?.userIds?.length
      );
    }

    @Prop({default: null})
    public missionOrderId: number;

    @Getter private isMobile: boolean;
    @Getter private envCompanyId: number|null;
    @Getter private canDoInEnvCompany: (right: string) => boolean;

    private showDialog: boolean = true;
    private loading: boolean = false;
    private assignedUserGroupId: number = null;
    private displayCreateUserGroup: boolean = false;
    private newUserGroup: any = null;
    private userGroupType: "contacts"|"subordinates" = null;
    private userGroupSearch: string = null;
    private userGroups: any = [];
    private userSearch: string = null;
    private users: any = [];

    @Watch("userSearch", {immediate: false})
    public handleUserSearch() {
      if (this.userSearch !== null) {
        return this.getContacts();
      }
    }

    @Watch("userGroupType", {immediate: false})
    private handlerUserGroupType() {
      this.assignedUserGroupId = null;
      if (this.newUserGroup) {
        this.newUserGroup.userIds = [];
      }
      if (!this.displayCreateUserGroup) {
        this.getUserGroups();
      }
      if (this.userGroupType === "contacts") {
        this.getContacts();
      } else {
        this.getSubordinates();
      }
    }

    private mounted(): void {
      this.reset();
    }

    private reset(): void {
      if (this.canDoInEnvCompany("READ_CONTACTS")) {
        this.userGroupType = "contacts";
      } else if (this.canDoInEnvCompany("READ_SUBORDINATES")) {
        this.userGroupType = "subordinates";
      }
      this.displayCreateUserGroup = false;
      this.resetUserGroupFields();
    }

    private cancelUserGroupCreation() {
      this.displayCreateUserGroup = false;
      this.resetUserGroupFields();
    }

    private resetUserGroupFields() {
      this.newUserGroup = {
        name: null,
        userIds: [],
      };
    }

    private displayCreateKeyGroupFields(): void {
      this.displayCreateUserGroup = true;
      this.assignedUserGroupId = null;
    }

    private cancel(): void {
      this.showDialog = false;
      this.$emit("close");
      this.reset();
    }

    private async confirm(): Promise<void> {
      if (this.displayCreateUserGroup) {
        await this.createUserGroup();
      }
      await this.assignMissionOrder();
    }

    private async createUserGroup(): Promise<void> {
        this.loading = true;
        await this.$store.dispatch("userGroups/create", {
            userGroupCreation: {
                name: this.newUserGroup.name,
                type: this.userGroupType,
                companyId: this.envCompanyId,
            },
            userIds: this.newUserGroup.userIds,
            companyId: this.envCompanyId,
        }).then((res) => {
            this.assignedUserGroupId = res.id;
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
            throw(error);
        }).finally(() => {
            this.loading = false;
        });
    }

    private async assignMissionOrder(): Promise<void> {
        this.loading = true;
        await this.$store.dispatch("missionOrders/assign", {
            id: this.missionOrderId,
            userGroupId: this.assignedUserGroupId,
        }).then(() => {
            this.showDialog = false;
            this.$store.commit("alerts/displaySuccess", {
              msg: this.$i18n.t("MissionOrders.assigned"),
            });
            this.$emit("reset");
            this.reset();
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loading = false;
        });
    }

    private getSubordinates() {
      if (!this.canDoInEnvCompany("READ_SUBORDINATES")) {
        return this.$store.commit("alerts/displayError", {
          msg: this.$t("alerts.error.cantFetchUsers"),
        });
      }
      return this.$store.dispatch("companies/getSubordinates", {
        id: this.envCompanyId,
        query: {
          page : 1,
          itemsPerPage : 10,
          search: this.userSearch,
        },
      }).then((data) => {
        this.users = data.users;
      });
    }

    private getContacts() {
      if (!this.canDoInEnvCompany("READ_CONTACTS")) {
        return this.$store.commit("alerts/displayError", {
          msg: this.$t("alerts.error.cantFetchUsers"),
        });
      }
      return this.$store.dispatch("companies/getContacts", {
        id: this.envCompanyId,
        query: {
          page : 1,
          itemsPerPage : 10,
          search: this.userSearch,
        },
      }).then((data) => {
        this.users = data.users;
      });
    }

    private getUserGroups() {
      this.$store.dispatch("companies/getUserGroups", {
        id: this.envCompanyId,
        query: {
          search: this.userGroupSearch,
          type: this.userGroupType,
        },
      }).then((data) => {
        this.userGroups = data.list;
      });
    }
}
